module.exports = __webpack_public_path__ + "img/turkey.b14f84f.webp";